<template lang="">
  <div class="chart-box">
    <div class="select-box">
      <el-select
        v-model="selectVal"
        placeholder="请选择"
        :popper-class="'select_type_cyzl'"
        @change="selectCity()"
      >
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index, item)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import { loadChart } from "../charts/cyfbData";
import { timerMixin } from "@/util/mixin/timerMixin";
import { getIndustrialDistribution } from "@/api/cyzl";
import { get } from "@/api/index";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["种植面积", "年产量"],
      active: 0,
      selectName: "种植面积",
      options: ["茂名市", "广东省", "全国", "全球"],
      selectVal: "茂名市",
      cityData: [], //保存茂名市数据
      proData: [], //保存茂名市与全省数据
      countryData: [], //保存茂名市与全国数据
      globalData: [] //保存茂名市与全球数据
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getChartsData();
    // this.getData();
    // this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, this.typeList[active], false);
    },
    changeType(index, name, clearT = true) {
      this.active = index;
      this.selectName = name;
      // this.getData();
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    },
    getChartsData() {
      get("/api/dp/visual/queryList?code=zl_cyfb").then(res => {
        if (res.data) {
          const pdData = res.data;

          //茂名与全省
          let proData = [];
          let proAreaList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_area)
            },
            {
              name: "省内其他地市",
              value: Number(pdData[1].fb_area) - Number(pdData[0].fb_area)
            }
          ];
          let proClList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_ncl)
            },
            {
              name: "省内其他地市",
              value: Number(pdData[1].fb_ncl) - Number(pdData[0].fb_ncl)
            }
          ];
          proData.push(proAreaList);
          proData.push(proClList);
          this.proData = proData;

          //茂名与全国
          let countryData = [];
          let countryAreaList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_area)
            },
            {
              name: "全国其他地区",
              value: Number(pdData[2].fb_area) - Number(pdData[0].fb_area)
            }
          ];
          let countryClList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_ncl)
            },
            {
              name: "全国其他地区",
              value: Number(pdData[2].fb_ncl) - Number(pdData[0].fb_ncl)
            }
          ];
          countryData.push(countryAreaList);
          countryData.push(countryClList);
          this.countryData = countryData;

          //茂名与全球
          let globalData = [];
          let globalAreaList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_area)
            },
            {
              name: "全球其他地区",
              value: Number(pdData[3].fb_area) - Number(pdData[0].fb_area)
            }
          ];
          let globalClList = [
            {
              name: pdData[0].fb_name,
              value: Number(pdData[0].fb_ncl)
            },
            {
              name: "全球其他地区",
              value: Number(pdData[3].fb_ncl) - Number(pdData[0].fb_ncl)
            }
          ];
          globalData.push(globalAreaList);
          globalData.push(globalClList);
          this.globalData = globalData;
        }

        this.initChart();
        this.startTimer();
      });
      getIndustrialDistribution().then(res => {
        if (res.data) {
          console.log("getIndustrialDistribution", res);
          if (res.data.maominData) {
            let cityData = [];
            let mmAreaList = [];
            let mmClList = [];
            res.data.maominData.forEach(ele => {
              mmAreaList.push({
                name: ele.name,
                value: Number(ele.area)
              });
              mmClList.push({
                name: ele.name,
                value: Number(ele.cl)
              });
            });
            cityData.push(mmAreaList);
            cityData.push(mmClList);
            this.cityData = cityData;
            this.initChart();
          }

          // old
          /* if (res.data.productDistribution) {
            const pdData = res.data.productDistribution;

            //茂名与全省
            let proData = [];
            let proAreaList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].area)
              },
              {
                name: "省内其他地市",
                value: Number(pdData[1].area) - Number(pdData[0].area)
              }
            ];
            let proClList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].cl)
              },
              {
                name: "省内其他地市",
                value: Number(pdData[1].cl) - Number(pdData[0].cl)
              }
            ];
            proData.push(proAreaList);
            proData.push(proClList);
            this.proData = proData;

            //茂名与全国
            let countryData = [];
            let countryAreaList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].area)
              },
              {
                name: "全国其他地区",
                value: Number(pdData[2].area) - Number(pdData[0].area)
              }
            ];
            let countryClList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].cl)
              },
              {
                name: "全国其他地区",
                value: Number(pdData[2].cl) - Number(pdData[0].cl)
              }
            ];
            countryData.push(countryAreaList);
            countryData.push(countryClList);
            this.countryData = countryData;

            //茂名与全球
            let globalData = [];
            let globalAreaList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].area)
              },
              {
                name: "全球其他地区",
                value: Number(pdData[3].area) - Number(pdData[0].area)
              }
            ];
            let globalClList = [
              {
                name: pdData[0].name,
                value: Number(pdData[0].cl)
              },
              {
                name: "全球其他地区",
                value: Number(pdData[3].cl) - Number(pdData[0].cl)
              }
            ];
            globalData.push(globalAreaList);
            globalData.push(globalClList);
            this.globalData = globalData;
          }

          this.initChart();
          this.startTimer(); */
        }
      });
    },

    initChart() {
      const unit = ["万亩", "万吨", "万元"];
      let yData = [];
      if (this.selectVal === "茂名市") {
        yData = this.cityData;
      } else if (this.selectVal === "广东省") {
        yData = this.proData;
      } else if (this.selectVal === "全国") {
        yData = this.countryData;
      } else {
        yData = this.globalData;
      }
      const fontSizes = 12;
      const widths = 10;
      const itemGaps = 10;
      loadChart(
        this.chart,
        yData[this.active],
        fontSizes,
        widths,
        itemGaps,
        unit[this.active],
        "2024"
      );
    },

    selectCity(clearT = true) {
      // if (this.selectVal !== "茂名市") {
      //   this.typeList = ["种植面积", "年产量"];
      // } else {
      //   this.typeList = ["种植面积", "年产量", "年产值"];
      // }
      this.active = 0;
      // this.getData();
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.flex
  display flex
  justify-content center

.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 15px
    // right 4%
    right 7%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .select-box
    width 90px
    height 30px
    position absolute
    // top -14%
    top -13%
    // right 21%
    right 19%
  /deep/.el-input__inner
    font-size 13px
    height 26px
    line-height 26px
    color #fff
    background-color #014555
    padding-left 7px
  /deep/.el-input__icon
    line-height 26px
  /deep/.el-select-dropdown__item
    color #00d0e8
    font-weight 500
</style>
<style>
.select_type_cyzl {
  background-color: #012032 !important;
}
.select_type_cyzl .el-select-dropdown__item {
  color: #00d0e8 !important;
}
.select_type_cyzl .el-select-dropdown__item.selected {
  color: rgb(252, 216, 52) !important;
}
.select_type_cyzl .el-select-dropdown__item.hover,
.select_type_cyzl .el-select-dropdown__item:hover {
  background-color: #0f7399 !important;
}
</style>
